import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  avatar: {
    cursor: "pointer",
    marginLeft: theme.spacing(2),
    marginTop: "0 !important",
    width: "33px",
    height: "33px",
    color: theme.palette.white.qrCode,
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(5),
    },
  },
  username: {
    textAlign: "center",
  },
}));
